"use client";

import React from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const trendingNames = [{
  name: "Aurelia",
  meaning: "The golden one",
  badgeText: "Trending",
  delay: "delay-0"
}, {
  name: "Silas",
  meaning: "Of the forest",
  badgeText: "Trending",
  delay: "delay-150"
}, {
  name: "Maeve",
  meaning: "She who intoxicates",
  badgeText: "Trending",
  delay: "delay-300"
}];
function AnimatedCard({
  item,
  index
}: {
  item: (typeof trendingNames)[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    rootMargin: "0px 0px -50px 0px"
  });
  return <div data-index={index} ref={ref} className={`relative h-full transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"} ${item.delay}`}>
      <Card className="h-full flex flex-col items-center justify-center p-10 border-2 border-accent bg-card relative overflow-hidden group hover:shadow-lg transition-shadow duration-300 rounded-none">
        <div className="absolute top-4 right-4">
          <Badge variant="secondary" className="uppercase tracking-wider text-[10px] px-3 py-1 rounded-none">
            {item.badgeText}
          </Badge>
        </div>
        
        <div className="flex-1 flex flex-col items-center justify-center w-full mt-6">
          <h3 className="text-5xl md:text-6xl lg:text-7xl font-bold text-primary mb-6 tracking-tighter text-center group-hover:scale-105 transition-transform duration-500">
            {item.name}
          </h3>
          <div className="w-12 h-[2px] bg-accent mb-6 opacity-50"></div>
          <p className="text-foreground text-center uppercase tracking-widest text-xs md:text-sm font-medium">
            {item.meaning}
          </p>
        </div>
      </Card>
    </div>;
}
export default function TrendingThisWeek() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section id="trending-this-week" className="bg-background py-24 md:py-32 overflow-hidden relative">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-accent/10 blur-3xl"></div>
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-card/30 blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={headerRef} className={`text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Trending This Week
          </h2>
          <p className="text-foreground/80 max-w-2xl mx-auto text-lg">
            Discover the names capturing hearts around the world right now.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {trendingNames.map((item, i) => <AnimatedCard key={item.name} item={item} index={i} />)}
        </div>
      </div>
    </section>;
}